
export default {
  props: {
    languagesList: {
      type: Array,
      required: true,
    },
    languageSelecting: Object,
  },
  data() {
    return {
      languageSelected: null,
    }
  },

  watch: {
    languageSelecting() {
      this.languageSelected = this.languageSelecting.language_code
    },
  },
  mounted() {
    this.languageSelected = this.$i18n.localeProperties.code
  },
  methods: {
    setLanguage(languageCode) {
      this.languageSelected = languageCode
      this.$emit('language-selected', languageCode)
    },
  },
}
